/**
 * CardArt — 카드 아트워크 한 장을 그리는 최소 부품.
 *
 * CardThumb 이 못 덮는 자리를 위해 뽑았다. CardThumb 은 목록 행·그리드 셀 두
 * 크기를 스스로 정하는데, 카드 상세의 대형 아트워크나 스캔 레일처럼 **바깥에서
 * 크기를 정하는 자리**가 있어 그쪽은 여전히 CARD_GRADIENTS 를 직접 발라 쓰고
 * 있었다. 그 자리들이 이미지 연결에서 통째로 빠졌다.
 *
 * 여기는 크기를 정하지 않는다 — 호출부가 className 으로 준다.
 *
 * ⚠ 이미지가 없거나 못 뜨면 colorKey 그라디언트가 그대로 보인다. 아무것도 안
 *   그리면 카드가 아니라 빈 칸으로 읽히므로 그라디언트를 **배경으로 깔아 둔 채**
 *   그 위에 이미지를 얹는다.
 */
import { CARD_GRADIENTS } from "../../data/dummyCards";
import styles from "./CardArt.module.css";

export interface CardArtProps {
  /**
   * dummyCards 의 colorKey — 이미지가 없을 때 깔리는 CARD_GRADIENTS 조회에 쓴다.
   * 실 카탈로그 카드에는 이 축이 없다 — 그때는 중립 플레이스홀더(.base 기본 배경)로 떨어진다.
   */
  colorKey?: string;
  /** 카드 아트워크. 없으면 그라디언트만 보인다 */
  imgUrl?: string;
  /** 크기·비율은 호출부가 정한다 */
  className?: string;
  /**
   * 스크린리더용 이름. 카드명이 옆에 이미 있으면 생략한다 —
   * 그 경우 장식이므로 aria-hidden 으로 빠진다.
   */
  ariaLabel?: string;
}

export default function CardArt({ colorKey, imgUrl, className, ariaLabel }: CardArtProps) {
  return (
    <span
      className={`${styles.base}${className ? ` ${className}` : ""}`}
      style={colorKey ? { background: CARD_GRADIENTS[colorKey] } : undefined}
      role={ariaLabel ? "img" : undefined}
      aria-label={ariaLabel}
      aria-hidden={ariaLabel ? undefined : true}
    >
      {imgUrl && (
        /* alt 는 늘 비운다 — 이름은 바깥 span 의 aria-label 이나 옆의 카드명이
           말한다. 여기서 또 읽으면 같은 이름이 두 번 들린다. */
        <img className={styles.art} src={imgUrl} alt="" loading="lazy" decoding="async" />
      )}
    </span>
  );
}
